export default __webpack_public_path__ + "static/media/r_js.dd495beb.png";